import { Injectable } from '@angular/core';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import {
  PaxFormControlBase,
  PaxFormControlTextbox,
  PaxFormControlDropdown
} from './../../shared/index';

@Injectable()
export class FormVehiclesInformationService {

  constructor() {}

  getTruckInfo() {

    // todo: get data from store?
    let questions: PaxFormControlBase<any>[] = [

      // Truck - Year
      new PaxFormControlTextbox({
        key: 'truckYear',
        label: 'Year',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 1
      }),

      // Truck - Make
      new PaxFormControlTextbox({
        key: 'truckMake',
        label: 'Make',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 2
      }),

      // Truck - Model
      new PaxFormControlTextbox({
        key: 'truckModel',
        label: 'Model',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 3
      }),

      // Truck - 17 digit VIN Number
      new PaxFormControlTextbox({
        key: 'truckVinNumber',
        label: '17 digit VIN Number',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }, {
          name: 'pattern',
          condition: /^[a-z0-9]+$/i,
          message: 'Letters and numbers only'
        }, {
          name: 'minLength',
          condition: 17,
          message: 'Enter a valid VIN number'
        }, {
          name: 'maxLength',
          condition: 17,
          message: 'Enter a valid VIN number'
        }],
        maxLength: 17,
        order: 4
      }),

      // Truck - How Much do you want to insure your truck for?
      new PaxFormControlTextbox({
        key: 'truckValue',
        label: 'How Much do you want to insure your truck for?',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        mask: createNumberMask({ prefix: '$' }),
        order: 5
      }),

      // Truck - Loss Payee Name
      new PaxFormControlTextbox({
        key: 'truckLossPayeeName',
        label: 'Loss Payee Name',
        order: 6
      }),

      // Truck - Loss Payee Address
      new PaxFormControlTextbox({
        key: 'truckLossPayeeAddress',
        label: 'Loss Payee Address',
        order: 7
      }),

      // Truck - Loss Payee Loan Number
      new PaxFormControlTextbox({
        key: 'truckLossPayeeLoanNumber',
        label: 'Loss Payee Loan Number',
        order: 8
      })
    ];

    return questions.sort((a, b) => a.order - b.order);
  }

  getTrailerInfo() {
    let questions: PaxFormControlBase<any>[] = [

      // Trailer - Year
      new PaxFormControlTextbox({
        key: 'trailerYear',
        label: 'Year',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 1
      }),

      // Trailer - Make
      new PaxFormControlTextbox({
        key: 'trailerMake',
        label: 'Make',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 2
      }),

      // Trailer - Model
      new PaxFormControlTextbox({
        key: 'trailerModel',
        label: 'Model',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 3
      }),

      // Trailer - Type
      new PaxFormControlDropdown({
        key: 'trailerType',
        label: 'Type',
        options: [
          { key: 'typeBox', value: 'Box' },
          { key: 'typeRefrigerated', value: 'Refrigerated' },
          { key: 'typeFlatBed', value: 'Flat bed' },
          { key: 'typeOther', value: 'Other' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 4
      }),

      // Trailer - 17 digit VIN Number
      new PaxFormControlTextbox({
        key: 'trailerVinNumber',
        label: '17 digit VIN Number',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }, {
          name: 'pattern',
          condition: /^[a-z0-9]+$/i,
          message: 'Letters and numbers only'
        }, {
          name: 'minLength',
          condition: 17,
          message: 'Enter a valid VIN number'
        }, {
          name: 'maxLength',
          condition: 17,
          message: 'Enter a valid VIN number'
        }],
        maxLength: 17,
        order: 6
      }),

      // Trailer - How Much do you want to insure your trailer for?
      new PaxFormControlTextbox({
        key: 'trailerValue',
        label: 'How Much do you want to insure your trailer for?',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        mask: createNumberMask({ prefix: '$' }),
        order: 7
      }),

      // Trailer - Loss Payee Name
      new PaxFormControlTextbox({
        key: 'trailerLossPayeeName',
        label: 'Loss Payee Name',
        order: 8
      }),

      // Trailer - Loss Payee Address
      new PaxFormControlTextbox({
        key: 'trailerLossPayeeAddress',
        label: 'Loss Payee Address',
        order: 9
      }),

      // Trailer - Loss Payee Loan Number
      new PaxFormControlTextbox({
        key: 'trailerLossPayeeLoanNumber',
        label: 'Loss Payee Loan Number',
        order: 10
      })
    ];

    return questions.sort((a, b) => a.order - b.order);
  }

  // Trailer - Other type
  getQuestionOtherTrailerType(): PaxFormControlBase<any> {
    return new PaxFormControlTextbox({
      key: 'trailerOtherType',
      label: 'Other type',
      order: 5
    });
  }

  getGenericQuestionText(opts): PaxFormControlBase<any> {
    return new PaxFormControlTextbox(opts);
  }

  sortQuestions(questions) {
    return questions.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/form-vehicles-information/form-vehicles-information.service.ts